import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import Filter, { FilterModel } from '../../components/Filter/Filter';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import { upsertFilterToKey } from '../../services/filterService';
import { WorkerModel } from '../../components/Invoice/InvoiceWorkers';
import CustomSelect from '../../components/CustomSelect/CustomSelect';

export class PayrollFilterFields extends FilterModel {
  worker?: number | null;

  constructor(data: any = {}) {
    super(data);
    this.worker = data.worker;
  }

  public get totalFilters(): number {
    let total = 0;
    if (this.worker) total += 1;
    if (this.q) total += 1;
    return total;
  }
}

interface PayrollsFilterProps {
  onSubmit: (data: PayrollFilterFields) => void;
  filterFields: PayrollFilterFields;
  pageKey: string;
}

export default function PayrollsFilter({
  onSubmit,
  filterFields,
  pageKey,
}: PayrollsFilterProps) {
  const { control, register, handleSubmit, reset } =
    useForm<PayrollFilterFields>({
      mode: 'onBlur',
    });
  const {
    user: { organization },
  } = useAuth();

  const [workers, setWorkers] = useState<WorkerModel[]>([]);
  const [workersLoading, setWorkersLoading] = useState(false);

  async function getWorkers() {
    if (organization) {
      setWorkersLoading(true);
      const { data } = await api.get(
        `admin/organizations/${organization.id}/users/workers`
      );
      setWorkers(data.data);
      setWorkersLoading(false);
    }
  }

  const clear = () => {
    reset({
      worker: null,
      q: null,
      skip: 0,
      take: 25,
    });
    upsertFilterToKey(pageKey, {});
  };

  useEffect(() => {
    reset(filterFields);
  }, [filterFields]);

  useEffect(() => {
    getWorkers();
  }, [organization]);

  return (
    <Filter
      isLoading={workersLoading}
      onSubmit={handleSubmit(onSubmit)}
      clear={clear}
      totalApplied={filterFields?.totalFilters || 0}
    >
      <form onSubmit={handleSubmit(onSubmit)} style={{ minHeight: '20rem' }}>
        <div className='mb-3'>
          <input
            {...register('q')}
            className='form-control'
            placeholder='Digite para pesquisar'
            type='text'
          />
        </div>
        <div className='mb-3'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label className='form-label'>Colaborador</label>
          <Controller
            name='worker'
            control={control}
            render={({ field }) => (
              <CustomSelect
                options={workers
                  .map((worker: any) => ({
                    label: worker.name,
                    value: worker.id,
                  }))
                  .sort((a: any, b) => (a.label > b.label ? 1 : -1))}
                value={field.value ?? ''}
                onChange={field.onChange}
                placeholder='Selecione o Colaborador'
              />
            )}
          />
        </div>
      </form>
    </Filter>
  );
}
